import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import styled from 'styled-components';


import server from 'server/serverController2';
import { getQueryStringObject} from 'utils/utils';

import GenderAndBirthScene from 'components/containers/signup/GenderAndBirthScene';
import UserCategoryScene from 'components/containers/signup/UserCategoryScene';
import UserDetailCategoryScene from 'components/containers/signup/UserDetailCategoryScene';
import PhoneSMSAuthScene from 'components/containers/signup/PhoneSMSAuthScene';

import TitleHeader from 'components/presenters/header/TitleHeader';
import CenterModal from 'components/presenters/modal/CenterModal';
import LottieLoader from 'components/containers/common/LottieLoader';
//LottieFile And ImageFile
import loadingAnimation from 'images/lottiefile/yellow_loading_animation.json'

export default function WritePersonalLayout() {
    const userInfo = useSelector((state) => {
        return state.userInfo;
    })

    const queryString = getQueryStringObject();
    const redirectPath = queryString.redirect_path;
    
    const [currScene, setCurrScene] = useState(0);
    const [personalDataFormScene, setPersonalDataFormScene] = useState([]);
    
    const [phone, setPhone] = useState(null);
    const [phoneToken, setPhoneToken] = useState(null);
    const [sex, setSex] = useState(null);
    const [birth, setBirth] = useState(null);
    const [parentCategories, setParentCategories] = useState([]);
    const [detailCategories, setDetailCategories] = useState([]);

    const [personalData, setPersonalData] = useState({});
    const [categoryNoList, setCategoryNoList] = useState([]);

    //CenterModal
    const [initCenterModal, setInitCenterModal] = useState(false);
    const [centerModalVisible, setCenterModalVisible] = useState(false);
    const [centerModalDataList, setCenterModalDataList] = useState({});
    const [onModalComplete, setOnModalComplete] = useState(null);
    const [onModalCancel, setOnModalCancel] = useState(null);

    const [isEmptyValue, setIsEmptyValue] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [lottieOptions, setLottieOptions] = useState(null);

    const history = useHistory();

    useEffect(() => {
        if(userInfo.isLogin)
        {
            console.log('personaldata check start');
            if(isLoading) return;
            setIsLoading(true);
            setLottieOptions({
                loop: true,
                autoplay: true,
                renderer: 'svg',
                animationData: loadingAnimation
            })
            server.getRequestData('users/personal', (res) => {
                if(res.success !== 1)
                {
                    // const errData = res.error.res_data;
                    setIsEmptyValue(true);
                    return;
                }
    
                const jsonData = res.data;
            
                // if(jsonData.phone)
                // {
                //     setPhone(jsonData.phone);
                // }
                // if(jsonData.sex)
                // {
                //     setSex(jsonData.sex);
                // }
                // if(jsonData.birth)
                // {
                //     setBirth(jsonData.birth);
                // }

                setPersonalData(jsonData);
            });

            server.getRequestData('users/categories', (res) => {
                if(res.success !== 1)
                {
                    setIsEmptyValue(true);
                    return;
                }
                const jsonData = res.data;
                
                if(jsonData.categories)
                {
                    const categoryNoArr = jsonData.categories.map((category) => category.category_no);
                    setCategoryNoList(categoryNoArr);
                }
            })
        }
        return;
    }, [])

    useEffect(() => {
        if(isLoading && Object.keys(personalData).length !== 0 && categoryNoList.length !== 0)
        {
            for(let key in personalData)
            {
                if(!personalData[key])
                {
                    setIsEmptyValue(true);
                    break;
                }
            }
            
            if(categoryNoList.length === 0)
            {
                setIsEmptyValue(true);
            }
        }
    }, [personalData, categoryNoList, isLoading])

    useEffect(() => {
        if(isEmptyValue)
        {
            if(personalData.phone)
            {
                setPhone(personalData.phone);
            }
            if(personalData.sex)
            {
                setSex(personalData.sex);
            }
            if(personalData.birth)
            {
                setBirth(personalData.birth)
            }
            handleSetPersonalDataScene();
        }
        else if(!isEmptyValue && Object.keys(personalData).length !== 0 && categoryNoList.length !== 0)
        {
            if(redirectPath)
            {
                history.replace(redirectPath);
            }
            else
            {
                history.goBack();
            }
        }
        
    }, [isEmptyValue, personalData, categoryNoList, currScene])


    const handleSetPersonalDataScene = () => {
        const newPersnalDataScene = [];
        let totalScene = 0;
        if(!personalData?.phone)
        {
            ++totalScene;
        }
        if(!personalData?.sex || !personalData?.birth)
        {
            ++totalScene;
        }
        if(categoryNoList?.length === 0)
        {
            totalScene += 2;
        }

        if(!personalData?.phone)
        {
            newPersnalDataScene.push(
                <PhoneSMSAuthScene 
                    totalSceneNum={totalScene}
                    currSceneNum={currScene+1}
                    onComplete={(data) =>{
                        setPhone(data['phone'])
                        setPhoneToken(data['token']);
                        if(totalScene !== currScene+1)
                        {
                            setCurrScene(currScene+1);
                        }
                        else
                        {

                        }
                    }}
                    onError={(error) => {
                        if(error['detail_code'] === 'SMS_DATA_NOT_EXIST')
                        {
                            setCenterModalVisible(true);
                            setCenterModalDataList({description:"인증번호가 맞지 않아요."});
                            setOnModalComplete(()=>()=>{
                                setInitCenterModal(true);
                            })
                        }
                        else if(error['detail_code'] === 'TIME_EXCEEDED')
                        {
                            setCenterModalVisible(true);
                            setCenterModalDataList({description:"시간이 초과되었어요.\n 다시 시도해 주세요."});
                            setOnModalComplete(()=>()=>{
                                setInitCenterModal(true);
                            })
                        }
                    }}
                />
            )
        }
        if(!personalData.sex || !personalData.birth)
        {
            newPersnalDataScene.push(
                <GenderAndBirthScene
                    initSex={sex}
                    initBirth={birth}
                    totalSceneNum={totalScene}
                    currSceneNum={currScene+1}
                    onComplete={(data) =>{
                        setSex(data.sex);
                        setBirth(data.birth);
                        if(totalScene !== currScene+1)
                        {
                            setCurrScene(currScene+1); 
                        }
                    }}
                    onError={() => {}}
                />
            )
        }

        if(categoryNoList.length === 0)
        {
            newPersnalDataScene.push(
                <UserCategoryScene 
                    totalSceneNum={totalScene}
                    currSceneNum={currScene+1}
                    onComplete={(data) =>{
                        setParentCategories(data['categories'])
                        if(totalScene !== currScene+1)
                        {
                           
                            setCurrScene(currScene+1); 
                        }
                    }}
                    onError={() => {}}
                />
            )

            newPersnalDataScene.push(
                <UserDetailCategoryScene 
                    totalSceneNum={totalScene}
                    currSceneNum={currScene+1}
                    parentCategories={parentCategories}
                    onComplete={async (data) =>{
                        setDetailCategories(data['categories']);
                        if(totalScene !== currScene+1)
                        {
                           return;
                        }
                        else
                        {
                        
                        }
                    }}
                    onError={() => {}}
                />
            )
        }
        setPersonalDataFormScene(newPersnalDataScene);
        setIsLoading(false);
    }

    useEffect(() => {
        if(phone && sex && birth && (parentCategories.length !== 0 && detailCategories.length !== 0 || categoryNoList.length !== 0))
        {
            handleSubmit();
        }
    }, [phone, sex, birth, parentCategories, detailCategories, categoryNoList]);

    useEffect(() => {
        if(initCenterModal)
        {
            setCenterModalVisible(false);
            setCenterModalDataList({})
            setOnModalComplete(null);
            setOnModalCancel(null);
            setInitCenterModal(false);
        }
    }, [initCenterModal])

    const printCurrSignupScene = () => { 
        return personalDataFormScene[currScene];
    }

    const handleSubmit = () => {
        
        const personalDataBody = {};
        if(phone && phoneToken)
        {
            personalDataBody['phone'] = phone;
        }
        if(phoneToken)
        {
            personalDataBody['phone_token'] = phoneToken;
        }
        if(sex)
        {
            personalDataBody['sex'] = sex;
        }
        if(birth)
        {
            personalDataBody['birth'] = birth;
        }
        
        server.putRequestData('users/personal', personalDataBody, (res) => {
            if(res.success !== 1)
            {
                return;
            }
        })

        const categoriesBody = {};
        
        if(parentCategories.length !== 0 && detailCategories.length !== 0)
        {
            categoriesBody['category_no_list'] = [...parentCategories, ...detailCategories].map((data) => data.no);
        }
        else if(categoryNoList.length !== 0)
        {
            categoriesBody['category_no_list'] = categoryNoList;
        }
        
        server.putRequestData('users/categories',categoriesBody, (res) => {
            if(res.success !== 1)
            {
                return;
            }
        })

        if(redirectPath)
        {
            history.replace(redirectPath);
            return;
        }
        history.goBack();
    }

    return (
        <>
            <PersonalDataFormSection>
                {isLoading ? (
                    <LottieAnimationWrapper>
                        <LottieLoader lottieOptions={lottieOptions} style={{width: 'calc(100vw * (45 / 375))'}}/>
                    </LottieAnimationWrapper>
                ) : (
                    <>
                        <HeaderWrapper>
                            <TitleHeader 
                                title={''}
                                onBackBtn={()=>{
                                    if(currScene <= 0)
                                    {
                                        history.goBack();
                                    }
                                    else
                                    {
                                        console.log('currScene')
                                        console.log(currScene)
                                        setCurrScene(currScene-1)
                                    }
                                }}
                            />
                        </HeaderWrapper>
                        <BodyWrapper>
                            {printCurrSignupScene()}
                        </BodyWrapper>
                    </>
                )}
                
            </PersonalDataFormSection>
            <CenterModal 
                modalVisible={centerModalVisible} 
                dataList={centerModalDataList} 
                onComplete={onModalComplete} 
                onCancel={onModalCancel}
            />
        </>
    )
}

const PersonalDataFormSection = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
`;

const LottieAnimationWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;

const HeaderWrapper = styled.div`
    flex: 0 1 auto;
    height: calc(100vw * (51 / 375));
    max-height: calc(100vw * (51 / 375));
`;

const BodyWrapper = styled.div`
    flex: 1 1 auto;
    height: 100%;
`;